import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { Logo } from "./Header";
import { waLink, PHONE, EMAIL } from "../lib/api";

export const Footer = () => (
  <footer className="bg-[#0A192F] text-slate-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
      <div className="md:col-span-1">
        <Logo light />
        <p className="mt-5 text-sm text-slate-400 leading-relaxed">
          Practical Tally, GST & TDS training built around real-world accounting. Learn. Practice. Grow.
        </p>
        <a
          href={waLink()}
          target="_blank"
          rel="noreferrer"
          data-testid="footer-whatsapp-link"
          className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#25D366] hover:text-white transition-colors"
        >
          <MessageCircle size={16} /> WhatsApp us anytime
        </a>
      </div>
      <div>
        <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-4">Courses</h4>
        <ul className="space-y-2.5 text-sm">
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/courses/tally-gst-tds">Practical Tally + GST + TDS</Link></li>
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/courses/tally-prime">Tally Prime Mastery</Link></li>
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/courses/gst-practical-training">GST Practical Training</Link></li>
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/courses/tds-practical-training">TDS Practical Training</Link></li>
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/courses">All Courses</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-4">Company</h4>
        <ul className="space-y-2.5 text-sm">
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/about">About Us</Link></li>
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/services">Professional Services</Link></li>
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/careers">Careers</Link></li>
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/blog">Knowledge Centre</Link></li>
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/testimonials">Testimonials</Link></li>
          <li><Link className="hover:text-[#C59B27] transition-colors" to="/faq">FAQ</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider mb-4">Contact</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex items-start gap-2.5">
            <Phone size={15} className="mt-0.5 text-[#C59B27] shrink-0" />
            <a href="tel:+919076400577" className="hover:text-white transition-colors">{PHONE}</a>
          </li>
          <li className="flex items-start gap-2.5">
            <Mail size={15} className="mt-0.5 text-[#C59B27] shrink-0" />
            <a href={`mailto:${EMAIL}`} className="hover:text-white transition-colors">{EMAIL}</a>
          </li>
          <li className="flex items-start gap-2.5">
            <MapPin size={15} className="mt-0.5 text-[#C59B27] shrink-0" />
            <span>Sterling Nest Institute, First Floor, Unnat Nagar No.03, M G Road, Goregaon West, Mumbai</span>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <span>© {new Date().getFullYear()} SterlingNest.in — All rights reserved.</span>
        <div className="flex gap-5">
          <Link to="/privacy-policy" className="hover:text-slate-300 transition-colors">Privacy Policy</Link>
          <Link to="/terms-and-conditions" className="hover:text-slate-300 transition-colors">Terms & Conditions</Link>
        </div>
      </div>
    </div>
  </footer>
);
